import { useHistory } from "react-router-dom";
import { TypeOption } from "constant";
import ActionLayout from "components/events/EventDetail/ActionPanel/components/ActionLayout";
import VariableActionIcon from "assets/svg/evaluate-backdrop.svg";

type VariableActionProps = {
    eventId: string;
    showDeleteConfirm: any;
    action: any;
    eventVariableAction: any;
    checkEditable: any;
};

const VariableAction = ({
    eventId,
    showDeleteConfirm,
    action,
    eventVariableAction,
    checkEditable,
}: VariableActionProps) => {
    const history = useHistory();

    const renderVariableContent = () => {
        const { value } = action.resource;
        let actionDescription = value?.capitalize();
        if (
            TypeOption.Counter === eventVariableAction?.type_ &&
            value === "reset"
        ) {
            actionDescription = "Reset to initial value";
        } else if (
            TypeOption.Timer === eventVariableAction?.type_ &&
            value === "reset_start"
        ) {
            actionDescription = "Reset and Start";
        } else if (
            TypeOption.Timer === eventVariableAction?.type_ &&
            value === "stop_reset"
        ) {
            actionDescription = "Stop and Reset";
        }

        return (
            <>
                <p className="mt-2 mb-3 default-white-color">Event Variable</p>
                <div className="variable-details">
                    <p className="default-white-color mb-2">
                        {eventVariableAction?.name}
                    </p>
                    <p className="mb-2">
                        Type:{" "}
                        {eventVariableAction?.type_.toLowerCase().capitalize()}
                    </p>
                    <p className="default-white-color mb-0">
                        Action:{" "}
                        {[TypeOption.Float, TypeOption.Integer].includes(
                            eventVariableAction?.type_
                        )
                            ? "Modify value with mathematical expression"
                            : actionDescription}
                    </p>
                </div>
            </>
        );
    };

    const renderActionIcon = () => {
        return <img src={VariableActionIcon} alt="action-variable-icon" />;
    };

    return (
        <ActionLayout
            showDeleteConfirm={showDeleteConfirm}
            editAction={(e) => {
                const isEditable = checkEditable(e);
                if (isEditable) {
                    history.push(
                        `/event-details/${eventId}/action/event-variable/${action.resource.variable}`,
                        {
                            actionPayload: {
                                action: action.resource.value,
                                uuid: action.uuid,
                                variables: action.resource.variables,
                                variable: eventVariableAction,
                            },
                        }
                    );
                }
            }}
            renderActionIcon={renderActionIcon}
        >
            {renderVariableContent()}
        </ActionLayout>
    );
};

export default VariableAction;
